import React from 'react';
import { useQuery } from '@apollo/react-hooks';
import { gql } from 'apollo-boost';
import { getRolePermissions } from '../permissions';

const CHECK_BACKUP_CONFIG = gql`
  query CheckBackupConfig {
    isBackupConfigured
  }
`;

const withRoleNavItems = (role, enableProductAssistant, enableInsights) => WrappedComponent => {
    return props => {
        const isSuper = role === 'superuser';
        const { data } = useQuery(CHECK_BACKUP_CONFIG, { skip: !isSuper, fetchPolicy: 'cache-first' });
        const isBackupConfigured = !!data?.isBackupConfigured;

        const rolePermissions = getRolePermissions(role, enableProductAssistant, enableInsights);
        let navItems = [];
        if (Array.isArray(rolePermissions) && rolePermissions.length) {
            let filteredPermissions = rolePermissions;
            if (isSuper) {
                filteredPermissions = rolePermissions.filter(rp => {
                    if (rp.route.getNavPath?.() === '/superuser/database') {
                        return isBackupConfigured;
                    }
                    return true;
                });
            }
            navItems = filteredPermissions.filter(rp => rp.menu && rp.menu !== null && rp.menu !== undefined).map(rp => { return { link: rp.route.getNavPath?.() || rp.route.path, ...rp.menu } })
        }
        return <WrappedComponent navItems={navItems} {...props} />
    }
}

export default withRoleNavItems;
